import Vue from 'vue'
import VueRouter from 'vue-router'
import BrochureIndex from '../views/BrochureIndex.vue'
import SignDc2026 from '../views/SignDc2026.vue'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'BrochureIndex',
    component: BrochureIndex
  },
  {
    path: '/SIGN/DC/2026',
    name: 'SignDc2026',
    component: SignDc2026
  },
  {
    path: '/legacy',
    name: 'Home',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash, offset: { y: 80 } }
    }
    return { x: 0, y: 0 }
  }
})

export default router
